const LLD_WAITING_USERS_PENDING = 'lld_waiting_users_pending';
const LLD_WAITING_USERS_FAILED = 'lld_waiting_users_failed';
const LLD_WAITING_USERS_DOWNLOADED = 'lld_waiting_users_downloaded';
const LLD_WAITING_USERS_REMOVED = 'lld_waiting_users_removed';
const LLD_WAITING_USERS_SENDING = 'lld_waiting_users_sending';

export {
  LLD_WAITING_USERS_DOWNLOADED,
  LLD_WAITING_USERS_FAILED,
  LLD_WAITING_USERS_PENDING,
  LLD_WAITING_USERS_REMOVED,
  LLD_WAITING_USERS_SENDING,
};



// WEBPACK FOOTER //
// ./src/store/lldWaitingUsers/types.js